import { RootState } from '@/app/store'

export const selectNotificationsState = (state: RootState) =>
	state.notifications
export const selectIsNotificationsOpen = (state: RootState) =>
	state.notifications.isNotificationsOpen
